import { enhanceOptionsSchemaWithDynamicOptions } from '../utils';

export const imageOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    src: {
        description: 'URL of an image file. All browser-supported image formats are acceptable.',
        type: 'string',
    },
    preserveAspectRatio: {
        default: false,
        description: 'Set to true to maintain the aspect ratio of an image when the screen is resized.',
        type: 'boolean',
    },
    title: {
        description:
            'Specify the title used as alternative text for the image. This text is read by screen readers and displayed when the image cannot be shown.',
        type: 'string',
    },
});
